export const interestOptions = [
  { value: 'rastreabilidade', label: 'Rastreabilidade do rebanho' },
  { value: 'sanitario', label: 'Controle sanitário e vacinação' },
  { value: 'credito_rural', label: 'Crédito rural e financiamento' },
  { value: 'gestao_propriedade', label: 'Gestão de propriedade' },
  { value: 'outro', label: 'Outro' },
] as const;

export type InterestValue = typeof interestOptions[number]['value'];